import { useStore } from 'vuex'
import { onMounted, computed, onUpdated, ref } from 'vue'

import closeSliderGripBehaviour from './methods/closeSliderGripBehaviour'
import onTransitionendCallback from './methods/onTransitionendCallback'

import BurgerMenu from 'components/BurgerMenu/BurgerMenu.vue'
import SearchOverlay from 'components/SearchOverlay/SearchOverlay.vue'
import GlobalProfileLoginOverlay from 'components/GlobalProfileLoginOverlay/GlobalProfileLoginOverlay.vue'
import ProfileOverlay from 'components/ProfileOverlay/ProfileOverlay.vue'
import ProfileEditedOverlay from 'components/ProfileEditedOverlay/ProfileEditedOverlay.vue'
import DeleteGlobalProfileOverlay from 'components/DeleteGlobalProfileOverlay/DeleteGlobalProfileOverlay.vue'
import FilterOverlay from 'components/FilterOverlay/FilterOverlay.vue'
import ArticleOverlay from 'components/ArticleOverlay/ArticleOverlay.vue'
import SignUpForm from 'components/SignUpForm/SignUpForm.vue'
import FlowEditModal from 'components/FlowEditModal/FlowEditModal.vue'
import PersonalDonation from 'components/PersonalDonationStep2a/PersonalDonationStep2a.vue'
import MemberListOverlayCancerforum from 'components/MemberListOverlayCancerforum/MemberListOverlayCancerforum.vue'
import MemberListOverlayFrivillig from 'components/MemberListOverlayFrivillig/MemberListOverlayFrivillig.vue'
import MemberOverlay from 'components/MemberOverlay/MemberOverlay.vue'
import MemberOverlayProfileCard from 'components/MemberOverlayProfileCard/MemberOverlayProfileCard.vue'
import ClosedGroupOverlay from 'components/ClosedGroupOverlay/ClosedGroupOverlay.vue'
import CreateFolderOverlay from 'components/CreateFolderOverlay/CreateFolderOverlay.vue'
import CreateNewFileOverlay from 'components/CreateNewFileOverlay/CreateNewFileOverlay.vue'
import ConfirmDeleteOverlay from 'components/ConfirmDeleteOverlay/ConfirmDeleteOverlay.vue'
import DeleteRoleOverlay from 'components/DeleteRoleOverlay/DeleteRoleOverlay.vue'
import UploadNewFileOverlay from 'components/UploadNewFileOverlay/UploadNewFileOverlay.vue'
import MoveFileOverlay from 'components/MoveFileOverlay/MoveFileOverlay.vue'
import HoldetsLys from 'components/HoldetsLys/HoldetsLys.vue'
import HoldetsDeltagere from 'components/HoldetsDeltagere/HoldetsDeltagere.vue'
import HoldetsDonationer from 'components/HoldetsDonationer/HoldetsDonationer.vue'
import TilmeldHoldKvittering from 'components/TilmeldHoldKvittering/TilmeldHoldKvittering.vue'
import HoldOprettelseKvittering from 'components/HoldOprettelseKvittering/HoldOprettelseKvittering.vue'
import HoldRedigerKvittering from 'components/HoldRedigerKvittering/HoldRedigerKvittering.vue'
import HoldetsRoundCounterOverlay from 'components/HoldetsRoundCounterOverlay/HoldetsRoundCounterOverlay.vue'
import ConfirmChanges from 'components/ConfirmChanges/ConfirmChanges.vue'
import OpretHoldOverlay from 'components/OpretHoldOverlay/OpretHoldOverlay.vue'
import ChangesSaved from 'components/ChangesSaved/ChangesSaved.vue'
import ProfileDeleted from 'components/ProfileDeleted/ProfileDeleted.vue'
import ConfirmDeleteProfile from 'components/ConfirmDeleteProfile/ConfirmDeleteProfile.vue'
import LoginOverlay from 'components/LoginOverlay/LoginOverlay.vue'
import DonationReceiptOverlay from 'components/DonationReceiptOverlay/DonationReceiptOverlay.vue'
import TilmeldProfilKvittering from 'components/TilmeldProfilKvittering/TilmeldProfilKvittering.vue'
import DeleteCancerProfileModal from 'components/DeleteCancerProfileModal/DeleteCancerProfileModal.vue'
import DeletePostOverlay from 'components/DeletePostOverlay/DeletePostOverlay.vue'
import DeleteCommentOverlay from 'components/DeleteCommentOverlay/DeleteCommentOverlay.vue'
import CalendarOverlay from 'components/CalendarOverlay/CalendarOverlay.vue'
import DeleteEventModal from 'components/DeleteEventModal/DeleteEventModal.vue'
import FrivilligeShopWrongRoleModal from 'components/FrivilligeShopWrongRoleModal/FrivilligeShopWrongRoleModal.vue'
import FVLConfirmDeleteProfile from 'components/FVLConfirmDeleteProfile/FVLConfirmDeleteProfile.vue'
import FundraisingQrCodeOverlay from 'components/FundraisingQrCodeOverlay/FundraisingQrCodeOverlay.vue'
import DeleteFrivilligjobOverlay from 'components/DeleteFrivilligjobOverlay/DeleteFrivilligjobOverlay.vue'

export default {
    name: 'PageOverlay',
    components: {
        BurgerMenu,
        ConfirmChanges,
        ConfirmDeleteProfile,
        OpretHoldOverlay,
        ChangesSaved,
        SearchOverlay,
        GlobalProfileLoginOverlay,
        ProfileOverlay,
        ProfileEditedOverlay,
        DeleteGlobalProfileOverlay,
        LoginOverlay,
        DonationReceiptOverlay,
        FilterOverlay,
        HoldetsDeltagere,
        HoldetsDonationer,
        HoldetsLys,
        ArticleOverlay,
        SignUpForm,
        ProfileDeleted,
        FlowEditModal,
        PersonalDonation,
        MemberListOverlayCancerforum,
        MemberListOverlayFrivillig,
        MemberOverlay,
        MemberOverlayProfileCard,
        ClosedGroupOverlay,
        CreateFolderOverlay,
        CreateNewFileOverlay,
        UploadNewFileOverlay,
        ConfirmDeleteOverlay,
        DeleteRoleOverlay,
        MoveFileOverlay,
        ClosedGroupOverlay,
        DeleteFrivilligjobOverlay,
        TilmeldHoldKvittering,
        TilmeldProfilKvittering,
        HoldOprettelseKvittering,
        HoldetsRoundCounterOverlay,
        HoldRedigerKvittering,
        DeleteCancerProfileModal,
        DeletePostOverlay,
        DeleteCommentOverlay,
        DeleteEventModal,
        FrivilligeShopWrongRoleModal,
        CalendarOverlay,
        FVLConfirmDeleteProfile,
        FundraisingQrCodeOverlay
    },
    setup() {
        const store = useStore()
        const closeOverlay = function () {
            store.dispatch('main/closePageOverlay')

            // on Frivillige document pages the active overlay mode should be set when overlay activated
            // when overlay closed, mode needs to be cleared - modes can be: "Dokument" or "Mappe"
            store.dispatch('frivillige/setActiveOverlayMode', { mode: "" }) 
            store.dispatch('frivillige/setEditModeActive', { mode: false }) 
        }

        let overlayContent = computed(
            () => store.state.main.page_overlay_content
        )

        const overlayState = computed(() => {
            return store.state.main.page_overlay_open === null
                ? 'ready'
                : store.state.main.page_overlay_open
                  ? 'open'
                  : 'closed'
        })

        const displayOverlayContent = computed(() => {
            return overlayState.value === 'open'
        })

        let first, last, close
        const overlayContentRef = ref(null)

        const tabTrap = function (e) {
            if (!e.shiftKey && e.target.dataset.order === 'close') {
                e.preventDefault()
                if (first) {
                    first.focus()
                } else if (document.querySelector('[data-order=first]')) {
                    first = document.querySelector('[data-order=first]')
                    first.focus()
                // If the first focusable element is the TinyMCE editor in ClosedGroupOverlay
                // then we need to focus on the editor inside it
                } else if (overlayContentRef.value?.getEditor()) {
                    overlayContentRef.value.getEditor().focus()
                }
            }
            if (e.shiftKey && e.target.dataset.order === 'close') {
                e.preventDefault()
                if (last) {
                    last.focus()
                } else if (document.querySelector('[data-order=last]')) {
                    last = document.querySelector('[data-order=last]')
                    last.focus()
                }
            }
        }

        function setTabTargets() {
            close = document.querySelector('.kb-page-overlay__close')
            first = document.querySelector('[data-order="first"]')
            last = document.querySelector('[data-order="last"]')
            last = last ? last : first
        }

        onUpdated(() => {
            setTabTargets()
        })

        onMounted(() => {
            close = document.querySelector('.kb-page-overlay__close')
            first = document.querySelector('[data-order="first"]')
            last = document.querySelector('[data-order="last"]')
            last = last ? last : first
            closeSliderGripBehaviour(store)
            onTransitionendCallback(
                {
                    closing() {
                        store.commit('main/reset_page_overlay')
                    }
                },
                { persistent: true }
            )
        })

        return {
            closeOverlay,
            overlayContentRef,
            displayOverlayContent,
            tabTrap,
            overlayContent,
            setTabTargets,
            overlayState
        }
    }
}
